import React from 'react';
import './Footer.css';
import { 
  MailOutlined,
  WechatFilled
} from '@ant-design/icons';

const Footer: React.FC = () => {
  // 页脚链接数据 - 与页头导航对应
  const footerColumns = [
    {
      title: '产品中心',
      links: [
        { title: '软件产品', url: '/products/software' },
        { title: '云服务', url: '/products/cloud' }
      ]
    },
    {
      title: '解决方案',
      links: [
        { title: '行业解决方案', url: '/solutions/industry' },
        { title: '技术解决方案', url: '/solutions/tech' },
        { title: '定制开发', url: '/solutions/custom' }
      ]
    },
    {
      title: '关于我们',
      links: [
        { title: '团队简介', url: '/about/company' },
        { title: '报告发布', url: '/about/history' },
        { title: '联系我们', url: '/about/contact' },
        { title: '加入我们', url: '/about/contact/joinus' }
      ]
    }
  ];

  // 联系信息
  const contactInfo = [
    { icon: <WechatFilled />, text: 'lyz300' },
    { icon: <MailOutlined />, text: 'i7isoft@163.com' }
  ];

  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* <div className="footer-main">
          <div className="footer-links">
            {footerColumns.map((column, index) => (
              <div key={index} className="footer-column">
                <h3 className="footer-column-title">{column.title}</h3>
                <ul className="footer-link-list">
                  {column.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a href={link.url} className="footer-link">
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="footer-contact">
            <h3 className="footer-contact-title">联系我们</h3>
            <ul className="contact-info-list">
              {contactInfo.map((item, index) => (
                <li key={index} className="contact-info-item">
                  <span className="contact-icon">{item.icon}</span>
                  <span>{item.text}</span>
                </li>
              ))}
            </ul>
            
            <div className="footer-beian">
              <div className="beian-item">
                <span className="beian-icon">🛡️</span>
                <a 
                  href="https://beian.miit.gov.cn/" 
                  rel="noreferrer" 
                  target="_blank"
                  className="icp-link"
                >
                  蜀ICP备2026013844号
                </a>
              </div>
              <div className="beian-item">
                <img 
                  src="/images/other/51010802033207.png" 
                  alt="公安备案图标" 
                  className="beian-icon-img"
                />
                <a 
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=51010802033207" 
                  rel="noreferrer" 
                  target="_blank"
                  className="beian-link"
                >
                  川公网安备51010802033207号
                </a>
              </div>
            </div>
          </div>
        </div> */}

        <div className="footer-bottom">
          <div className="copyright">
            © {new Date().getFullYear()} 数海穹览(iaya.cn) 版权所有
            &nbsp;&nbsp;
            <span className="beian-icon">🛡️</span>
                <a 
                  href="https://beian.miit.gov.cn/" 
                  rel="noreferrer" 
                  target="_blank"
                  className="icp-link"
                >
                  蜀ICP备2026048526号-1
                </a>
              &nbsp;&nbsp;
                <img 
                  src="/images/other/51010502015910.png" 
                  alt="公安备案图标" 
                  className="beian-icon-img"
                />
                <a 
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=51010502015910" 
                  rel="noreferrer" 
                  target="_blank"
                  className="beian-link"
                >
                  川公网安备51010502015910号
                </a>
          </div>
           {/* 备案信息 - 换行显示 */}
            <div className="footer-beian">
              <div className="beian-item">
                
              </div>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;